import { LOGIN_MODAL_SHOW } from '../constants';
import { post } from '../Services/http';

export const showLogin = (open) => ({
  type: LOGIN_MODAL_SHOW,
  payload: {
    open,
  },
});

export const signOut = () => {
  post('/api/login/logout').then(() => (location.href = '/'));
};
